import * as Long from "long";
import { EMPTY, from } from "rxjs";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
export var pathBuyProductNotEnoughResource = function (action, state$, deps) {
    var resourceInfo = selectResourceInfo(action.itemId);
    if (resourceInfo.buyValue && resourceInfo.buyValue.resourceId === IdResource.Money) {
        var requiredAmount = action.amount * resourceInfo.buyValue.amount;
        var missingResources = [
            {
                amount: Long.fromValue(requiredAmount),
                stageId: 0,
                typeId: IdResource.Money,
            },
        ];
        return from([
            actionOngoingPurchaseStandardSelect([
                {
                    missingResources: missingResources,
                    missingType: IdMissingResourceTypes.Dollar,
                },
            ]),
            actionModalOpen(IdModal.NotEnoughResource),
        ]);
    }
    return EMPTY;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/paths/pathBuyProductNotEnoughResource.ts
// module id = 2452
// module chunks = 3